import React from "react";

const ProjectDetailSection = ({ formData, setFormData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData("projectDetails", {
      ...formData.projectDetails,
      [name]: value,
    });
  };

  return (
    <>
      <div className="form-section">
        <h3>Details of Project</h3>
        <div className="form-group">
          <label className="required">Name of the Project</label>
          <input
            type="text"
            name="projectName"
            value={formData.projectDetails.projectName}
            onChange={handleInputChange}
            placeholder="Enter Project Name"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Project Proposal For</label>
          <select
            name="projectProposal"
            value={formData.projectDetails.projectProposal}
            onChange={handleInputChange}
            required
          >
            <option value="">Select</option>
            <option value="new">New</option>
            <option value="expansion">Expansion</option>
          </select>
        </div>
        <div className="form-group">
          <label className="required">Project ID (Single Window Number)</label>
          <input
            type="text"
            name="projectId"
            value={formData.projectDetails.projectId}
            onChange={handleInputChange}
            placeholder="Example: SW/100472/2022"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Description of Project</label>
          <textarea
            name="description"
            value={formData.projectDetails.description}
            onChange={handleInputChange}
            placeholder="Enter Project Description"
            required
          />
        </div>
      </div>
      <div className="form-section">
        <h3>
          Details of the Company/Organisation/User Agency making application
        </h3>
        <div className="form-group">
          <label className="required">
            Legacy status of the Company/Organisation/User Agency
          </label>
          <input
            type="text"
            name="legacyStatus"
            value={formData.projectDetails.legacyStatus}
            onChange={handleInputChange}
            placeholder="Enter Legacy Status"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">
            Name of the Company/Organisation/User Agency
          </label>
          <input
            type="text"
            name="companyName"
            value={formData.projectDetails.companyName}
            onChange={handleInputChange}
            placeholder="Enter Company Name"
            required
          />
        </div>
        <h4>Registered Address</h4>
        <div className="form-group">
          <label className="required">Address</label>
          <input
            type="text"
            name="address"
            value={formData.projectDetails.address}
            onChange={handleInputChange}
            placeholder="Enter Address"
            required
          />
        </div>
        <div className="form-group">
          <label>Village/Town/City</label>
          <input
            type="text"
            name="city"
            value={formData.projectDetails.city}
            onChange={handleInputChange}
            placeholder="Enter Village/Town/City"
          />
        </div>
        <div className="form-group">
          <label className="required">State</label>
          <input
            type="text"
            name="state"
            value={formData.projectDetails.state}
            onChange={handleInputChange}
            placeholder="Enter State"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">District</label>
          <input
            type="text"
            name="district"
            value={formData.projectDetails.district}
            onChange={handleInputChange}
            placeholder="Enter District"
            required
          />
        </div>
        <div className="form-group">
          <label className="required">Pincode</label>
          <input
            type="number"
            name="pincode"
            value={formData.projectDetails.pincode}
            onChange={handleInputChange}
            placeholder="Enter Pincode"
            required
          />
        </div>
        <div className="form-group">
          <label>Landmarks</label>
          <input
            type="text"
            name="landmarks"
            value={formData.projectDetails.landmarks}
            onChange={handleInputChange}
            placeholder="Enter Landmarks"
          />
        </div>
        <div className="form-group">
          <label className="required">E-mail address</label>
          <input
            type="email"
            name="email"
            value={formData.projectDetails.email}
            onChange={handleInputChange}
            placeholder="Enter Email ID"
            required
          />
        </div>
        <div className="form-group">
          <label>Landline Number</label>
          <input
            type="number"
            name="landlineNumber"
            value={formData.projectDetails.landlineNumber}
            onChange={handleInputChange}
            placeholder="Enter Landline Number"
          />
        </div>
        <div className="form-group">
          <label className="required">Mobile Number</label>
          <input
            type="number"
            name="phoneNumber"
            value={formData.projectDetails.phoneNumber}
            onChange={handleInputChange}
            placeholder="Enter Mobile Number"
          />
        </div>
      </div>
    </>
  );
};

export default ProjectDetailSection;
